import React, { useMemo } from 'react';
import jmoment from 'moment-jalaali';
import packageJson from '../../../package.json';
import './footer.scss';

const Footer = () => {
  const year = useMemo(() => jmoment(new Date()).format('jYYYY'), []);
  return (
    <footer className='app-footer'>
      <div className='container d-flex justify-content-center'>
        <p className='d-flex'>
          <span>{locales('messages.copyright.text', { year })} - ورژن: </span>
          <strong className='d-flex'>{packageJson.version}</strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
